var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCashflow = function SvgCashflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 3v18.5M17.5 6H9.708c-.85 0-1.667.316-2.268.879A2.9 2.9 0 0 0 6.5 9c0 .796.338 1.559.94 2.121A3.33 3.33 0 0 0 9.708 12h4.584c.85 0 1.667.316 2.268.879.602.562.94 1.325.94 2.121s-.338 1.559-.94 2.121a3.33 3.33 0 0 1-2.268.879H6.5"
  })));
};
export { SvgCashflow as ReactComponent };
export default __webpack_public_path__ + "6b5581d290cd166cf486f2a52598c329.svg";